import { getApiBaseUrl, getApiKey } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'

const API_URL = getApiBaseUrl().replace(/\/+$/, '')
const API_KEY = getApiKey()

const authHeaders = () => {
    const token = localStorage.getItem('accessToken')
    return token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
}

const parsePayload = (config) => {
    try {
        return JSON.parse(config?.data || '{}')
    } catch (error) {
        console.error('warehouse parsePayload error', error)
        return {}
    }
}

const toProxyError = (error) => {
    const status = Number(error?.response?.status) || 500
    const data = error?.response?.data
    if (data && typeof data === 'object') return [status, data]
    const debug = String(data || error?.message || 'Ошибка складского API')
    return [status, { error: 'Warehouse Backend Error', errorInfo: 'Ошибка складского API. Подробности выведены в консоль браузера', debug }]
}

Mock.onGet(/\/api\/warehouse\/(?:reports|inventory)\/export(?:\?.*)?$/).reply(async (config) => {
    const query = String(config?.url || '').split('?')[1] || ''
    const localPath = String(config?.url || '').split('?')[0]
    const remotePath = `${localPath.replace(/^\/api/, '')}/`.replace(/\/{2,}/g, '/')
    try {
        const response = await axios.get(`${API_URL}${remotePath}?apiKey=${API_KEY}${query ? `&${query}` : ''}`, {
            ...(authHeaders() || {}),
            responseType: 'arraybuffer',
        })
        return [response?.status || 200, response?.data, response?.headers || {}]
    } catch (error) {
        return toProxyError(error)
    }
})

Mock.onPost(/\/api\/warehouse\/.+/).reply(async (config) => {
    const localPath = String(config?.url || '').split('?')[0]
    const remotePath = `${localPath.replace(/^\/api/, '')}/`.replace(/\/{2,}/g, '/')
    try {
        const response = await axios.post(
            `${API_URL}${remotePath}?apiKey=${API_KEY}`,
            parsePayload(config),
            authHeaders(),
        )
        const responseData = response?.data
        if (responseData && typeof responseData === 'object') return [response?.status || 200, responseData]
        const raw = String(responseData || '').trim()
        try {
            const parsed = JSON.parse(raw)
            if (parsed && typeof parsed === 'object') return [response?.status || 200, parsed]
        } catch (error) {
            // Ниже вернём безопасный диагностический ответ вместо строки с HTTP 200.
        }
        console.error('warehouse proxy invalid backend response', { path: remotePath, response: raw.slice(0, 2000) })
        return [500, { error: 'Invalid Warehouse Backend Response', errorInfo: 'Backend склада вернул некорректный ответ. Подробности выведены в консоль браузера', debug: raw || 'Backend склада вернул пустой ответ' }]
    } catch (error) {
        console.error('warehouse proxy error', {
            path: remotePath,
            status: error?.response?.status,
            response: error?.response?.data,
        })
        return toProxyError(error)
    }
})
